__turbopack_context__.v({
  "age": "default-module-sass-module__4hPWzq__age",
  "beGambleAware": "default-module-sass-module__4hPWzq__beGambleAware",
  "footer": "default-module-sass-module__4hPWzq__footer",
  "footerLogo": "default-module-sass-module__4hPWzq__footerLogo",
  "footerSite": "default-module-sass-module__4hPWzq__footerSite",
  "footerText": "default-module-sass-module__4hPWzq__footerText",
  "nav": "default-module-sass-module__4hPWzq__nav",
  "txt": "default-module-sass-module__4hPWzq__txt",
  "version": "default-module-sass-module__4hPWzq__version",
});
